// Microsoft Graph API Configuration
export const graphConfig = {
  appId: process.env.REACT_APP_GRAPH_CLIENT_ID || '295c6881-4c77-4347-868d-129c204cc5f3',
  authority: process.env.REACT_APP_GRAPH_AUTHORITY || 'https://login.microsoftonline.com/c1771266-aabc-4127-8797-7eaad953e8bc',
  redirectUri: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000',
};

// Permission scopes for Microsoft Graph
export const graphScopes = [
  'Mail.Send',
  'Mail.ReadWrite',
  'User.Read',
  'Files.ReadWrite',
  'Files.ReadWrite.All'
]; 